import React from 'react';
import './ContactUs.css';
import { t } from 'i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { toastSubject } from '../../subjects/GlobalSubjects';

// Validation Schema using Yup
const validationSchema = yup.object().shape({
  name: yup.string().required(t('contactUs.form.errors.nameRequired')),
  email: yup.string().email(t('contactUs.form.errors.invalidEmail')).required(t('contactUs.form.errors.emailRequired')),
  phone: yup.string().matches(/^[0-9]{10}$/, t('contactUs.form.errors.invalidPhone')).required(t('contactUs.form.errors.phoneRequired')),
  message: yup.string().required(t('contactUs.form.errors.messageRequired')),
});

interface ContactRequest {
  name: string;
  email: string;
  phone: string;
  message: string;
}

const ContactUs: React.FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(validationSchema, undefined, undefined),
    defaultValues: {
      name: '',
      email: '',
      phone: '',
      message: '',
    },
  });

  const onSubmit = async (body: ContactRequest) => {
        const message = `
Name: ${body.name}
Email: ${body.email}
Phone: ${body.phone}
Message: ${body.message}
    `.trim();

    const encodedMessage = encodeURIComponent(message);
    const whatsappNumber = "919810014363"; // Ensure this is correct and includes country code

    const whatsappURL = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodedMessage}`;
    window.open(whatsappURL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='contact-container'>
      <div className='comment-form-container'>
        <h2>{t('contactUs.form.title')}</h2>
        <form className='comment-form' onSubmit={handleSubmit(onSubmit)}>
          <div className='comment-form-row' >
            {/* Name Field */}
            <div className='comment-form-element'>
              <input type='text' {...register('name')} autoComplete='name' placeholder={t('contactUs.form.namePrompt')} />
              <p className="error">{errors.name?.message as string}</p>
            </div>

            {/* Email Field */}
            <div className='comment-form-element comment-form-row-right'>
              <input type='email' {...register('email')} autoComplete='email' placeholder={t('contactUs.form.emailPrompt')} />
              <p className="error">{errors.email?.message as string}</p>
            </div>
          </div>

          {/* Phone Field */}
          <input type='tel' {...register('phone')} autoComplete='tel' placeholder={t('contactUs.form.phonePrompt')} />
          <p className="error">{errors.phone?.message as string}</p>

          {/* Message Field */}
          <textarea {...register('message')} placeholder={t('contactUs.form.messagePrompt')}></textarea>
          <p className="error">{errors.message?.message as string}</p>

          {/* Submit Button */}
          <button className='submit-button' type='submit'>{t('contactUs.form.submit')}</button>

        </form>
        <div className='contact-us-footer'>
          <a className='contact-us-footer-item' href={`mailto:${t('footer.contact.eValue')}`}>
              <p>{t('contactUs.contact.eValue')}</p>
          </a>
          <a className='contact-us-footer-item' href={`tel:${t('footer.contact.tValue')}`}>
              <p>{t('contactUs.contact.tValue')}</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
